// src/componentes/Dashboard/PlanDiaBanner.jsx
//
// Tile en dashboard que muestra el plan del día (modo oficina) con
// predicción vs real. Auto-oculto si no se ha generado plan.

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../Firebase/firebaseconfig";
import { hoyLocalISO } from "../../helpers/fechas";
import "./ReporteEjecutivoBanner.css";

// HOTFIX v1.1.3: hoy en zona LOCAL no UTC
const hoyIso = () => hoyLocalISO();

const PlanDiaBanner = () => {
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ref = doc(db, "planesDia", hoyIso());
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setPlan(snap.exists() ? snap.data() : null);
        setLoading(false);
      },
      () => setLoading(false),
    );
    return () => unsub();
  }, []);

  if (loading || !plan) return null;

  const cuentas = Array.isArray(plan.cuentas) ? plan.cuentas : [];
  const esperado = plan.totalEsperado || 0;
  const recuperado = plan.recuperadoReal || 0;
  const procesadas = plan.procesadas || 0;

  const fmt = (n) =>
    Number(n || 0).toLocaleString("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  const accuracy = esperado > 0 ? Math.round((recuperado / esperado) * 100) : 0;
  const avance = cuentas.length > 0 ? Math.round((procesadas / cuentas.length) * 100) : 0;

  return (
    <section
      className="rep-ej-banner"
      style={{
        background: "linear-gradient(135deg, #047857 0%, #10b981 100%)",
        cursor: "pointer",
      }}
      onClick={() => navigate("/app/plan-dia")}
    >
      <header className="rep-ej-header">
        <div>
          <h3>🤖 Plan del Día · {plan.fechaISO}</h3>
          <div className="rep-ej-kpis">
            <span className="rep-ej-down">🎯 {fmt(esperado)} esperado</span>
            <span className="rep-ej-sep">·</span>
            <span className="rep-ej-up">💰 {fmt(recuperado)} cobrado</span>
            <span className="rep-ej-sep">·</span>
            <span>{accuracy}% accuracy</span>
            <span className="rep-ej-sep">·</span>
            <span>
              {procesadas}/{cuentas.length} cuentas ({avance}%)
            </span>
          </div>
        </div>
        <button className="rep-ej-toggle">▶ Abrir plan</button>
      </header>
    </section>
  );
};

export default PlanDiaBanner;
